export default __webpack_public_path__ + "static/media/body-female-average.24cd61be.png";